// Экспорт функций для создания слоев карты

export const getPlotLayer = (conditions, source = 'park-data') => {
    const baseFilters = [
        ['==', '$type', 'Polygon'],
        ['==', 'type', 'plot'],
        ...conditions
    ];
    const suffix = source !== 'park-data' ? '-editing' : '';

    const basePaint = {
        'fill-color': [
            'case',
            ['==', ['get', 'color'], null], '#cccccc',
            ['has', 'color'], ['get', 'color'],
            '#cccccc'
        ],
        'fill-opacity': ['case', ['==', ['get', 'color'], 'transparent'], 0.0, 0.6],
        'fill-outline-color': ['case', ['==', ['get', 'color'], 'transparent'], 'transparent', 'rgba(0, 0, 0, 0.5)']
    };

    // Слой для участков без штриховки
    const solidLayer = {
        id: `plots-layer-solid${suffix}`,
        type: 'fill',
        source: source,
        filter: ['all', ...baseFilters, ['any', ['!has', 'hatch'], ['==', 'hatch', 'none']]],
        paint: basePaint
    };

    // Слой для заливки цветом участков со штриховкой (без паттерна)
    const hatchedColorLayer = {
        id: `plots-layer-hatched-color${suffix}`,
        type: 'fill',
        source: source,
        filter: ['all', ...baseFilters, ['has', 'hatch'], ['!=', 'hatch', 'none']],
        paint: {
            ...basePaint
        }
    };

    // Слой для паттерна штриховки (без цвета, только паттерн)
    const hatchedPatternLayer = {
        id: `plots-layer-hatched-pattern${suffix}`,
        type: 'fill',
        source: source,
        filter: ['all', ...baseFilters, ['has', 'hatch'], ['!=', 'hatch', 'none']],
        paint: {
            'fill-pattern': ['concat', 'hatch-', ['get', 'hatch']]
        }
    };

    return [solidLayer, hatchedColorLayer, hatchedPatternLayer];
};

export const getBuildingLayer = (conditions, type = '3d', source = 'park-data') => {
    const filters = [
        ['==', '$type', 'Polygon'],
        ['==', 'type', 'building'],
        ...conditions
    ];

    const baseLayer = {
        source: source,
        filter: ['all', ...filters],
    };
    const suffix = source !== 'park-data' ? '-editing' : '';
    if (type === '3d') {
        return [{
            id: `buildings-layer-3d${suffix}`,
            type: 'fill-extrusion',
            ...baseLayer,
            paint: {
                'fill-extrusion-color': [
                    'case',
                    ['==', ['get', 'color'], null], '#6c757d',
                    ['has', 'color'], ['get', 'color'],
                    '#6c757d'
                ],
                'fill-extrusion-height': [
                    'case',
                    ['all', ['has', 'height'], ['>', ['get', 'height'], 0]], ['*', ['get', 'height'], 5],
                    25
                ],
                'fill-extrusion-base': 0,
                'fill-extrusion-opacity': 0.8
            }
        }];
    } else {
        const basePaint = {
            'fill-color': [
                'case',
                ['==', ['get', 'color'], null], '#6c757d',
                ['has', 'color'], ['get', 'color'],
                '#6c757d'
            ],
            'fill-opacity': 0.4,
            'fill-outline-color': 'rgba(0, 0, 0, 0.5)'
        };

        const solidLayer = {
            id: `buildings-layer-2d-solid${suffix}`,
            type: 'fill',
            ...baseLayer,
            filter: ['all', ...filters, ['any', ['!has', 'hatch'], ['==', 'hatch', 'none']]],
            paint: basePaint
        };

        // Слой для заливки цветом зданий со штриховкой
        const hatchedColorLayer = {
            id: `buildings-layer-2d-hatched-color${suffix}`,
            type: 'fill',
            ...baseLayer,
            filter: ['all', ...filters, ['has', 'hatch'], ['!=', 'hatch', 'none']],
            paint: {
                ...basePaint
            }
        };

        // Слой для паттерна штриховки
        const hatchedPatternLayer = {
            id: `buildings-layer-2d-hatched-pattern${suffix}`,
            type: 'fill',
            ...baseLayer,
            filter: ['all', ...filters, ['has', 'hatch'], ['!=', 'hatch', 'none']],
            paint: {
                'fill-pattern': ['concat', 'hatch-', ['get', 'hatch']]
            }
        };

        return [solidLayer, hatchedColorLayer, hatchedPatternLayer];
    }
};

export const getRoadLayer = (conditions, source = 'park-data') => {
    const baseFilters = [
        ['==', '$type', 'LineString'],
        ['in', 'type', 'road', 'line'],
        ...conditions
    ];

    const basePaint = {
        'line-color': [
            'case',
            ['==', ['get', 'color'], null], '#808080', // Если color === null, используем серый
            ['has', 'color'], ['get', 'color'],         // Если color есть и не null, используем его
            '#808080'                                   // Во всех остальных случаях (если color нет)
        ],
        'line-width': ['case', ['==', ['get', 'subtype'], 'railway'], 4, 3],
        'line-opacity': 0.8
    };

    const baseLayout = {
        'line-join': 'round',
        'line-cap': 'round'
    };

    const suffix = source !== 'park-data' ? '-editing' : '';

    // Слой для сплошных линий (или где lineType не указан)
    const solidLayer = {
        id: `roads-layer-solid${suffix}`,
        type: 'line',
        source: source,
        filter: ['all', ...baseFilters, ['any', ['!has', 'lineType'], ['==', 'lineType', 'solid']]],
        layout: baseLayout,
        paint: {
            ...basePaint
            // 'line-dasharray' не задаём для сплошных линий
        }
    };

    // Слой для пунктирных линий
    const dashedLayer = {
        id: `roads-layer-dashed${suffix}`,
        type: 'line',
        source: source,
        filter: ['all', ...baseFilters, ['==', 'lineType', 'dashed']],
        layout: baseLayout,
        paint: {
            ...basePaint,
            'line-dasharray': [4, 2]
        }
    };

    // Слой для точечных линий
    const dottedLayer = {
        id: `roads-layer-dotted${suffix}`,
        type: 'line',
        source: source,
        filter: ['all', ...baseFilters, ['==', 'lineType', 'dotted']],
        layout: baseLayout,
        paint: {
            ...basePaint,
            'line-dasharray': [1, 2]
        }
    };

    return [solidLayer, dashedLayer, dottedLayer];
};

export const getMarkerLayer = (conditions, source = 'park-data') => {
    const filters = [
        ['==', '$type', 'Point'],
        ['==', 'type', 'marker'],
        ...conditions
    ];

    return {
        id: `markers-layer${source !== 'park-data' ? '-editing' : ''}`,
        type: 'symbol',
        source: source,
        filter: ['all', ...filters],
        layout: {
            'icon-image': ['coalesce', ['get', 'icon_filename'], 'default-marker'], // Используем 'default-marker' если icon_filename нет
            'icon-size': 0.08,
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,
            'icon-anchor': 'bottom' // Лучше для меток, чтобы острие указывало на точку
        }
    }
};

export const getStatusIconsLayer = (conditions) => ({
    id: 'status-icons',
    type: 'symbol',
    source: 'status-icons-source',
    filter: ['all', ...conditions], // Применяем условия фильтрации к слою иконок
    layout: {
        'icon-image': ['get', 'icon_image'],
        'icon-size': 0.5,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true
    }
});

/**
 * Слои с подписями (текстом)
 */
export const getPlotLabelLayer = (conditions, overrides = {}) => ({
    id: 'plots-labels-layer',
    type: 'symbol',
    source: 'park-data',
    filter: ['all', ['==', 'type', 'plot'], ...conditions],
    layout: {
        'text-field': overrides.textField || ['coalesce', ['get', 'name'], ['get', 'cadastral_number'], ''],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': overrides.size || 12,
        'text-offset': overrides.offset || [0, 0],
        'text-anchor': 'center',
        'text-allow-overlap': false,
        'visibility': overrides.visible === false ? 'none' : 'visible'
    },
    paint: {
        'text-color': '#000000',
        'text-halo-color': '#ffffff',
        'text-halo-width': 1.5
    }
});

export const getBuildingLabelLayer = (conditions, overrides = {}) => ({
    id: 'buildings-labels-layer',
    type: 'symbol',
    source: 'park-data',
    filter: ['all', ['==', 'type', 'building'], ...conditions],
    layout: {
        'text-field': overrides.textField || ['get', 'name'],
        'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Bold'],
        'text-size': overrides.size || 11,
        'text-offset': overrides.offset || [0, 0],
        'text-anchor': 'center',
        'text-allow-overlap': false,
        'visibility': overrides.visible === false ? 'none' : 'visible'
    },
    paint: {
        'text-color': '#000000',
        'text-halo-color': '#ffffff',
        'text-halo-width': 1.5
    }
});
